import { ICustomLogData, IPersonalizationLogger } from  "@ms-ofb/officepersonalization/dist/lib/Logging/Logger";
import * as Logging from "../Logging/Logging";

export class PersonalizationLogger implements IPersonalizationLogger {
	public error(message: string, ...data: unknown[]): void {
		Logging.getLogger().logEvent({name: message} as Logging.IEventId, Logging.LogLevel.Error, data as Logging.ICustomProperties);
	}
	public info(message: string, ...data: unknown[]): void {
		Logging.getLogger().logEvent({name: message} as Logging.IEventId, Logging.LogLevel.Info, data as Logging.ICustomProperties);
	}
	public warn(message: string, ...data: unknown[]): void {
		Logging.getLogger().logEvent({name: message} as Logging.IEventId, Logging.LogLevel.Info, data as Logging.ICustomProperties);
	}
	public trace(message: string, ...data: unknown[]): void {
		Logging.getLogger().logEvent({name: message} as Logging.IEventId, Logging.LogLevel.Info, data as Logging.ICustomProperties);
	}
	public event(eventName: string, customLogData?: ICustomLogData, samplingRatio = 1): void {
		Logging.getLogger().logEvent({name: eventName} as Logging.IEventId, Logging.LogLevel.Critical,
			customLogData as Logging.ICustomProperties, samplingRatio);
	}
	public userFactEvent(userFact: string, userFactValue: string): void {
		Logging.getUserFactLogger().logUserFact(userFact, userFactValue);
	}
}
